import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
// import css from './App.scss';
import Header from '../header/header';
import Login from '../login/login';
import Footer from '../footer/footer';
import Banner from '../banner/banner';
import UsersTable from '../usersTable/usersTable';
import ResetPassword from '../resetPassword/resetPassword';

class App extends Component {
	render() {
		return [
			<Header key="header" />,
			<Switch key="switch">
				<Route exact path="/" component={Login} />
				<Route
					exact
					path="/utilisateurs"
					component={_ => [
						<Banner key="banner" />,
						<UsersTable key="table" />,
					]}
				/>
				<Route exact path="/reset-password/:token" component={ResetPassword} />
				<Redirect to="/" />
			</Switch>,
			<Footer key="footer" />,
		];
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js